import script from "./recordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./recordPage.vue?vue&type=script&lang=ts&setup=true"

import "./recordPage.vue?vue&type=style&index=0&id=2560a8da&scoped=true&lang=scss"
import "./recordPage.vue?vue&type=style&index=1&id=2560a8da&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2560a8da"]])

export default __exports__